import Vue from 'vue'
import { login, logout, phoneLogin, thirdLogin } from '@/api/login'
import {
  DEFAULTHOMEINDEX,
  ACCESS_TOKEN,
  USER_NAME,
  USER_ID,
  USER_INFO,
  USER_AUTH,
  SYS_BUTTON_AUTH,
  UI_CACHE_DB_DICT_DATA,
  TENANT_ID,
  CACHE_INCLUDED_ROUTES,
  TENANTLIST,
  SETTINGS
} from '@/store/mutation-types'
import { welcome, getMenu, getUserId } from '@/utils/util'
import { queryPermissionsByUser } from '@/api/api'
import { getAction } from '@/api/manage'
import { clone } from 'lodash'

const user = {
  state: {
    token: '',
    username: '',
    realname: '',
    tenantid: '',
    userId: '',
    welcome: '',
    avatar: '',
    permissionList: [],
    info: {},
    // 系统安全模式
    sysSafeMode: null,
    layoutList: [],
    benchData: {
      workBenchData: {},
      layoutList: []
    },
    routes: new Map(),
    quickMenu: [],
    detailMap: new Map(),
    // 告警中心菜单权限
    alertCenterMenuAuth: null,
    defaultHomeIndex: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERID: (state, id) => {
      state.userId = id
    },
    SET_NAME: (state, { username, realname, welcome }) => {
      state.username = username
      state.realname = realname
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_TENANT: (state, id) => {
      state.tenantid = id
    },
    SET_SYS_SAFE_MODE: (state, sysSafeMode) => {
      if (typeof sysSafeMode === 'boolean') {
        state.sysSafeMode = sysSafeMode
      } else {
        state.sysSafeMode = false
      }
    },
    SET_BENCH_DATA: (state, data) => {
      state.benchData = data
    },
    SET_USER_ROUTES: (state, routes) => {
      state.routes = routes
    },
    SET_USER_MENU: (state, menu) => {
      state.quickMenu = menu
    },
    SET_DETAIL_MAP: (state, map) => {
      state.detailMap = map
    },
    SET_ALERT_MENU_AUTH: (state, auth) => {
      state.alertCenterMenuAuth = auth
    },
    SET_DEFAULT_INDEX: (state, homeIndex) => {
      state.defaultHomeIndex = homeIndex
    }
  },

  actions: {
    detailMapAction({ commit, state }, detail) {
      const { key, data } = detail
      const detailMap = clone(state.detailMap)
      detailMap.set(key, data)
      commit('SET_DETAIL_MAP', detailMap)
    },
    // CAS验证登录
    ValidateLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        getAction('/sys/cas/client/validateLogin', userInfo)
          .then(response => {
            console.log('----cas 登录--------', response)
            if (response.success) {
              const result = response.result
              const userInfo = result.userInfo
              Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)

              commit('SET_TOKEN', result.token)
              commit('SET_INFO', userInfo)
              commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname, welcome: welcome() })
              commit('SET_AVATAR', userInfo.avatar)
              resolve(response)
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 登录
    Login({ commit, dispatch }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then(response => {
            if (response.code == '200') {
              const result = response.result
              const userInfo = result.userInfo

              Vue.ls.set(USER_ID, result.userInfo.id, 7 * 24 * 60 * 60 * 1000)

              Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)

              Vue.ls.set(TENANTLIST, result.tenantList, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)

              Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)

              Vue.ls.set(SETTINGS, result.settings, 30 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', result.token)
              commit('SET_INFO', userInfo)
              commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname, welcome: welcome() })
              commit('SET_AVATAR', userInfo.avatar)

              commit('INIT_APP_SETTING', result.settings)

              dispatch('getUserCorp', userInfo)

              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    //手机号登录
    PhoneLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        phoneLogin(userInfo)
          .then(response => {
            if (response.code == '200') {
              const result = response.result
              const userInfo = result.userInfo

              Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', result.token)
              commit('SET_INFO', userInfo)
              commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname, welcome: welcome() })
              commit('SET_AVATAR', userInfo.avatar)
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取用户信息
    GetPermissionList({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        queryPermissionsByUser()
          .then(response => {
            const menuData = response.result.menu
            const authData = response.result.auth
            const allAuthData = response.result.allAuth
            const defaultIndex = response.result.defaultHome

            //Vue.ls.set(USER_AUTH,authData);
            sessionStorage.setItem(USER_AUTH, JSON.stringify(authData))
            sessionStorage.setItem(SYS_BUTTON_AUTH, JSON.stringify(allAuthData))

            // Vue.ls.set('DEFAULTHOMEINDEX', defaultIndex)
            // // 设置首页
            // commit('SET_DEFAULT_INDEX', defaultIndex)
            dispatch('changeDefaultHome', defaultIndex)
            if (menuData && menuData.length > 0) {
              // //update--begin--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
              // menuData.forEach((item, index) => {
              //   if (item["children"]) {
              //     let hasChildrenMenu = item["children"].filter((i) => {
              //       return !i.hidden || i.hidden == false
              //     })
              //     if (hasChildrenMenu == null || hasChildrenMenu.length == 0) {
              //       item["hidden"] = true
              //     }
              //   }
              // })
              // //console.log(" menu show json ", menuData)
              // //update--end--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
              commit('SET_PERMISSIONLIST', menuData)
              // 设置系统安全模式
              commit('SET_SYS_SAFE_MODE', response.result.sysSafeMode)
            } else {
              reject(null)
            }
            dispatch('LoadQuickMenu', menuData)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise(resolve => {
        let logoutToken = state.token
        commit('SET_TOKEN', '')
        commit('SET_PERMISSIONLIST', [])
        Vue.ls.remove(ACCESS_TOKEN)
        Vue.ls.remove(USER_INFO)
        Vue.ls.remove(USER_NAME)
        Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
        Vue.ls.remove(CACHE_INCLUDED_ROUTES)
        Vue.ls.remove(TENANT_ID)
        //console.log('logoutToken: '+ logoutToken)
        logout(logoutToken)
          .then(() => {
            if (process.env.VUE_APP_SSO == 'true') {
              let sevice = 'http://' + window.location.host + '/'
              let serviceUrl = encodeURIComponent(sevice)
              window.location.href = process.env.VUE_APP_CAS_BASE_URL + '/logout?service=' + serviceUrl
            }
            resolve()
          })
          .catch(() => {
            resolve()
          })
      })
    },
    // 第三方登录
    ThirdLogin({ commit }, param) {
      return new Promise((resolve, reject) => {
        thirdLogin(param.token, param.thirdType)
          .then(response => {
            if (response.code == '200') {
              const result = response.result
              const userInfo = result.userInfo
              Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', result.token)
              commit('SET_INFO', userInfo)
              commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname, welcome: welcome() })
              commit('SET_AVATAR', userInfo.avatar)
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    saveTenant({ commit }, id) {
      Vue.ls.set(TENANT_ID, id, 7 * 24 * 60 * 60 * 1000)
      commit('SET_TENANT', id)
    },
    async LoadQuickMenu({ commit, dispatch, state }, routes) {
      //获取当前用户配置的快捷菜单
      await dispatch('LoadUserQuickMenu')
      const loadMenuData = getMenu(routes, state.quickMenu)
      commit('SET_USER_ROUTES', loadMenuData)
    },

    async LoadUserQuickMenu({ commit }) {
      const { result } = await getAction('/custom/sysUserEntrance/list')
      console.info('menulength vuex===' + result.records.length)

      commit('SET_USER_MENU', result.records)
    },
    // SetMenuItem ({ commit, state }, menuItem) {
    //   const routes = state.routes
    //   routes.set(menuItem.id,{
    //     quickMenu
    //   })
    // }
    async refreshRoutes({ commit, state, dispatch }, menuItem) {
      await dispatch('LoadUserQuickMenu')
      let routeItem = {}
      let routeMap = new Map()
      if (menuItem.quickMenuId) {
        routeItem = { ...state.routes.get(menuItem.menuId) }
        delete routeItem.quickMenuId
      } else {
        // 获取快捷入口菜单数据
        const menu = state.quickMenu.find(item => item.permissionId === menuItem.menuId)
        routeItem = { ...state.routes.get(menuItem.menuId), quickMenuId: menu.id }
      }
      // routes.set(menu.permissionId, {
      //   ...state.routes.get(menuId),
      //   quickMenuId: menu.id

      // const routes = getMenu(state.routes, state.quickMenu)
      // commit('SET_USER_ROUTES', routes)
      state.routes.set(menuItem.menuId, routeItem)
      routeMap = state.routes
      commit('SET_USER_ROUTES', routeMap)
      // dispatch('LoadQuickMenu')
    },
    changeDefaultHome({ commit }, defaultIndex) {
      Vue.ls.set('DEFAULTHOMEINDEX', defaultIndex)
      // 设置首页
      commit('SET_DEFAULT_INDEX', defaultIndex)
    },
    async getUserCorp({ commit, dispatch, state }, userInfo) {
      const { result } = await getAction('wf/wfConsumerCorp/queryById', {
        id: userInfo.corpIds
      })
      if (result && result.id) {
        userInfo.corpInfo = result
        Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
        commit('SET_INFO', userInfo)
      }
    }
  }
}

export default user
